module.exports = __webpack_public_path__ + "media/homepage/pge-0a4785ca.png";